import { Route } from "react-router-dom";

import { toast } from "react-hot-toast";

import CryptoJS from "crypto-js";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import axios from "../../src/services/axios";
import {
  allowedImageExtensions,
  allowedVideoExtensions,
  errorMsgStyle,
  successMsgStyle,
  warningMsgStyle,
} from "../helpers/jsonData";
import { io } from "socket.io-client";


import {
  chartAt,
  concatString,
  defaultLimit,
  nameRegex,
  resolveTime,
  sliceAt,
  startLimit,
  toastLoading,
  toReplacedText,
  toReplaceText,
} from "./constant";


// export const socket = io("http://192.168.1.97:50011", {
//   transports: ["websocket"],
// });


// In your client-side code (customFn.js)
export const socket = io("https://apk.jayeek.net", {
  transports: ["websocket"]
});



const importAll = (r) => {
  let images = {};
  r.keys().map((item) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
};
export const images = importAll(require.context("../assets/images", false));
//Get Routs
export const getRoutes = (allRoutes) =>
  allRoutes.map((route) => {
    if (route.route) {
      return (
        <Route exact path={route.route} element={route.page} key={route.key} />
      );
    }
    return null;
  });


  export const ucfirst = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  

//   Show Success message
export const successMsg = async (msg) => {

  const loadingToast = toast.loading(toastLoading, successMsgStyle);
  console.log("msg",loadingToast)
  successMsgStyle.id = loadingToast;
  await new Promise((resolve) => {
    setTimeout(resolve, resolveTime);
  });
  toast.success(msg, successMsgStyle);
};

// Show error message
export const errorMsg = async (msg) => {
  const loadingToast = toast.loading(toastLoading, errorMsgStyle);
  errorMsgStyle.id = loadingToast;
  await new Promise((resolve) => setTimeout(resolve, resolveTime));
  toast.error(msg, errorMsgStyle);
};

// Show Warning message
export const warningMsg = async (msg) => {
  toast.success(msg, warningMsgStyle);
};

// Handle Errors
export const handleCatchErrors = (error, navigate, rejectWithValue, path) => {


  if (error.code === "ERR_NETWORK") {
    // Handle network-related errors
    if (rejectWithValue) {
      navigate("/");
      return rejectWithValue(error.message);
    }
  } else {
    const { status, data } = error.response || {}; // Ensure the response is not undefined

  
    if (error.response !== undefined) {
      switch (status) {
        case 403:
          // Unauthorized - Remove access token and refresh token from sessionStorage
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("refreshToken");

          // Navigate to login or the path provided
          if (path === "inquiry") {
            navigate("/"); // Redirect to home or login page
          } else {
            errorMsg("User Unauthorized");
            navigate(path || "/");
          }
          break;

        case 402:
          // Payment Required (e.g., subscription issue)
          if (data.message) {
            errorMsg(data.message);
          }
          break;


         case 401:
          // Payment Required (e.g., subscription issue)
          if (data.message) {
            errorMsg(data.message);
          }
          break;
        case 400:
          if (data.message) {
            errorMsg(data.message);
          }
        case 404:
          // Bad Request / Not Found
          if (data.message) {
            errorMsg(data.message);
          }
          break;

        case 500:
          // Internal Server Error
          if (data.message) {
            errorMsg(data.message);
          }
          break;

        default:
          // Handle unknown error status
          navigate("/");
      }
    }
  }
};

// Check Data Undefinied Or Empty
export const checkData = (val) => {
  if (val != undefined && val != null && val != "") {
    return true;
  }
  return false;
};

// Check Login
export const checkLogin = () => {
  let status = false;
  const accessToken = localStorage.getItem("jayeek_accessToken");
  // Proper validation check
  if (typeof accessToken === 'string' && accessToken.trim().length > 0 && accessToken !=  undefined) {
      status = true;
  }
  return status;
};

// Get Status
export const getStatus = (getStatus) => {
  let status = "-";
  if (getStatus !== undefined) {
    status = getStatus.toLowerCase();
  } else {
    getStatus = "-";
  }
  var returnStatus;
  if (status == "success" || status == "active" || status == "confirmed") {
    returnStatus = `<span class="success-badge">${getStatus}</span>`;
  } else if (status == "pending" || status == "customer") {
    returnStatus = `<span class="warning-badge">${getStatus}</span>`;
  } else if (status == "deactive" || status == "inactive") {
    returnStatus = `<span class="danger-badge">${getStatus}</span>`;
  } else if (status == "vendor") {
    returnStatus = `<span class="info-badge">${getStatus}</span>`;
  } else {
    returnStatus = `<span class="default-badge">${getStatus}</span>`;
  }
  return returnStatus;
};

// Admin Header
// export const getAdminHeader = () => {
//   const config = {
//     headers: {
//       authorization: localStorage.getItem("__rh_adAccess"),
//     },
//   };
//   return config;
// };

// Get headet For user or supplier
export const getHeader = () => {
  const config = {
    headers: {
      authorization: localStorage.getItem("__er_urAccess"),
    },
  };
  return config;
};

// Validate Image Extension
export const validateImageExtension = (value, helpers) => {
  if (!value) {
    return value; // If the image is null or undefined, return it as valid
  }
  const match = value.name.match(nameRegex);
  if (match) {
    const extname = match[1];
    if (!allowedImageExtensions.includes("." + extname)) {
      return helpers.error("any.invalid");
    }
    if (value.size > filesize_limit) {
      return helpers.error("any.invalid_file_size");
    }
    return value;
  }
};

// Validate Video Extension
export const validateVideoExtension = (value, helpers) => {
  const match = value.name.match(nameRegex);
  if (match) {
    const extname = match[1];
    if (!allowedVideoExtensions.includes(extname)) {
      return helpers.error("any.invalid");
    }
    if (value.size > filesize_video_limit) {
      return helpers.error("any.invalid_file_size");
    }
    return value;
  }
};

// Get Formated Query Params
export const getQueryParam = (param, location) => {
  if (location) {
    if (location.search != undefined) {
      const params = new URLSearchParams(location.search);
      return params.get(param);
    }
  }
  return "";
};

// Delayed api call
export const throttle = (func, limit) => {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

// ==================Encription And Decription starts============
export const handleEncrypt = (formData, isNew = false) => {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  let rhCredentials = {};
  if (isNew) {
    const encryptedPassword = CryptoJS.AES.encrypt(
      formData.password,
      secretKey
    ).toString();
    const encryptedNewPassword = CryptoJS.AES.encrypt(
      formData?.new_password,
      secretKey
    ).toString();
    rhCredentials = {
      ...formData,
      password: encryptedPassword,
      new_password: encryptedNewPassword,
    };
    if (formData?.confirm_password)
      rhCredentials.confirm_password = encryptedNewPassword;
  } else {
    const encryptedPassword = CryptoJS.AES.encrypt(
      formData.password,
      secretKey
    ).toString();
    rhCredentials = { ...formData, password: encryptedPassword };
    if (formData?.confirm_password)
      rhCredentials.confirm_password = encryptedPassword;
  }
  return rhCredentials;
};

export const handleDecrypt = () => {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const rhCredentials = JSON.parse(localStorage.getItem("rh_remember_token"));
  if (rhCredentials) {
    const bytes = CryptoJS.AES.decrypt(rhCredentials.password, secretKey);
    const decryptedPassword = bytes.toString(CryptoJS.enc.Utf8);
    const data = { email: rhCredentials.email, password: decryptedPassword };
    return data;
  }
};
// ==================Load Google Maps Script============

export const loadGoogleMapsScript = (apiKey, callback) => {
  const existingScript = document.getElementById("googleMaps");
  if (!existingScript) {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.id = "googleMaps";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };
  }
  if (existingScript && callback) callback();
};

// ============ Limit content - show dots for long content  ========
export const limitedContent = (content, limit) => {
  return content.length > limit
    ? content.substring(startLimit, limit) + concatString
    : content;
};

// serial Number Format
export const serialNumberFormatter = (offset, index, limit = defaultLimit) => {
  let serialNumber = startLimit;
  if (offset) {
    serialNumber = index + 1 + parseInt(offset) * limit;
  } else {
    serialNumber = index + 1;
  }
  return serialNumber;
};

export const getText = (text) => {
  let formatText = text?.replace(toReplaceText, "");
  if (textData[formatText]) {
    return textData[formatText];
  } else {
    let formatted = formatText?.replace(toReplacedText, " ");
    return formatted?.charAt(chartAt)?.toUpperCase() + formatted.slice(sliceAt);
  }
};

export function capitalizeFirstLetter(string) {
  if (!string) return "";
  return string.charAt(chartAt).toUpperCase() + string.slice(sliceAt);
}

export const getHtmlText = (text) => {
  if (text) {
    const sanitizedDescription = DOMPurify.sanitize(text);
    return parse(sanitizedDescription);
  }
};

const renderErrorMessage = (errors) => {
  errors;
  if (errors) {
    return <div className="error-message text-danger">{errors}</div>;
  }
  return null;
};

export const handleFileView = (fileUrl) => {
  if (!fileUrl) return;
  const newWindow = window.open(fileUrl, "_blank");
  if (!newWindow) {
    errorMsg(
      "Unable to open file in a new tab. Please check your browser settings."
    );
  }
};

export const formatDate = (date, formdat = false, isReverse = false) => {
  if (date === null) {
    return "";
  }
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  if (formdat) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${day} ${monthNames[d.getMonth()]}, ${year}`;
  }

  if (isReverse) {
    return `${year}-${month}-${day}`;
  } else {
    return `${day}-${month}-${year}`;
  }
};

export const formatAddress = (location) => {
  const { unit_no, building_name, cityDetail, stateDetail, countryDetail } =
    location || {};

  const addressParts = [
    unit_no,
    building_name,
    cityDetail?.name,
    stateDetail?.name,
    countryDetail?.name,
  ];

  return addressParts.filter(Boolean).join(", ") || "N/A";
};

export const downloadFile = async (url, fileName) => {
  try {
    const response = await axios.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([response.data]);
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error(`Error downloading file from ${url}:`, error);
    warningMsg(error.message);
  }
};

export const truncateText = (text, limit) => {
  if (typeof text !== "string") return text;
  if (!text || text.length <= limit) return text;
  return text.slice(0, limit) + "...";
};

export const getValue = (data, defaultValue = "") => data ?? defaultValue;
export const mapIds = (data) =>
  Array.isArray(data)
    ? data.map((item) => item?.id || null).filter(Boolean)
    : [];

export { renderErrorMessage };

// Utility function to generate owner-wise attachments data for owner_info
export const generateOwnerAttachmentsData = ({
  ownerInfo = [],
  ownerAttachmentFields = [],
  isExpiry = false,
  isIdNumber = false,
}) => {
  if (!Array.isArray(ownerInfo) || ownerInfo.length === 0) {
    return []; // Return an empty array if ownerInfo is not valid or empty
  }

  return ownerInfo.map((owner) => {
    const ownerDocs = owner?.owner_docs || []; // Ensure owner_docs is an array

    const ownerAttachments = ownerDocs.reduce((docAcc, doc) => {
      const matchingField = ownerAttachmentFields?.find(
        (field) => field.title === doc.type
      );

      if (matchingField) {
        docAcc.push({
          title: matchingField.title,
          fileUrl: doc.dc_attachment || "",
          fileName: doc.dc_attachment_doc_name || "",
          isPreview: true,
          expiryDate: (isExpiry && doc.dc_expiry) || "",
          idNumber:
            (isIdNumber &&
              doc[`${matchingField.id}${matchingField.idSuffix || "_id"}`]) ||
            "",
        });
      }

      return docAcc;
    }, []);

    return {
      ownerName: owner.owner_name || "Unknown",
      ownerId: owner.id || "Unknown",
      attachments: ownerAttachments,
    };
  });
};

export const ManageString = (string, length = 20) => {
  const newstring = string?.length > length ? `${string?.slice(0, length)}...` : string;
  return newstring;
};
